import taxasServices from '@/api/financial/taxasServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => taxasServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST', result.data.content)
      resolve(result)
    }).catch(err => reject(err)))
  },
  insertNew({ commit }, data) {
    return taxasServices.insertNew(data).then(result => result).catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT', data)
  },
  edit({ commit }, data) {
    return taxasServices.edit(data).then(result => result).catch(error => error)
  },
  reset({ commit }) {
    commit('RESET')
  },
  delete({ commit }, id) {
    return taxasServices.delete(id).then(result => result).catch(error => error)
  },
}
